// Detect if app is running in an iframe
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

// Get the parent domain if in iframe
export const getParentDomain = () => {
  try {
    if (isInIframe() && document.referrer) {
      const url = new URL(document.referrer);
      return url.hostname;
    }
  } catch (e) {
    console.error('Could not get parent domain:', e);
  }
  return null;
};

// Check if parent domain is allowed
export const isAllowedParentDomain = () => {
  const parentDomain = getParentDomain();
  const allowedDomains = [
    's.tiled.co',
    'tiled.co',
    'seismic.com',
    'app.seismic.com',
    'content.seismic.com'
  ];

  if (!parentDomain) return !isInIframe(); // Allow if not in iframe

  return allowedDomains.some(domain =>
    parentDomain === domain || parentDomain.endsWith(`.${domain}`)
  );
};

// Configure API for cross-origin requests
export const configureApiForIframe = () => {
  if (isInIframe()) {
    // Add any special configuration needed for iframe mode
    // For example, you might need to:
    // 1. Use a different auth method
    // 2. Add special headers
    // 3. Use postMessage for communication

    console.log('App is running in iframe from:', getParentDomain());

    if (!isAllowedParentDomain()) {
      console.warn('App is embedded in non-allowed domain');
    }
  }
};